module.exports = __webpack_public_path__ + "img/stock7.fab8c5c8.png";